<template>
    <div>
        <Loading v-bind:show="showLoadingButton">
            <md-content>
                <md-table v-model="searched" :md-sort="OrderBy" md-sort-order="desc" md-card @md-selected="onSelect" class="semMargin" items-per-page="5">
                    <md-table-toolbar>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item" v-if="exibirCombo1 == true">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{detalhesCombo1.titulo}}</label>
                                    <md-select v-model="combo1" name="combo1" id="combo1" @md-selected="changeCombo(combo1, 1)" class="filtro" style="color:#6361FB !important">
                                        <md-option :value="c.value" v-for="c in detalhesCombo1.dados" :key="c.value" class="option">
                                            {{c.text}}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item" v-if="exibirCombo2">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{detalhesCombo2.titulo}}</label>
                                    <md-select name="combo2" id="combo2" v-model="combo2" @md-selected="changeCombo(combo2, 2)" class="filtro">
                                        <md-option :value="c.value" v-for="c in detalhesCombo2.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>

                            <div class="md-layout-item" v-if="exibirCombo3">
                                <md-field>
                                    <label for="combo1" class="color6361FB">{{detalhesCombo3.titulo}}</label>
                                    <md-select name="combo3" id="combo3" v-model="combo3" @md-selected="changeCombo(combo3, 3)" class="filtro">
                                        <md-option :value="c.value" v-for="c in detalhesCombo3.dados" :key="c.value" class="option">{{c.text}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout-item padding-pesquisar align-right">
                            <md-field class="md-toolbar-section-end">
                                <md-input placeholder="Pesquisar..." v-model="search" @input="searchOnTable" class="filtro color6361FB webkit-text-fill-color6361FB" />
                                <button v-on:click="limparPesquisa" class="buttonLimpar">
                                    <md-icon>backspace</md-icon>
                                    <md-tooltip md-direction="top">Limpar pesquisa</md-tooltip>
                                </button>
                            </md-field>
                        </div>

                    </md-table-toolbar>

                    <md-table-empty-state md-label="Nenhum resultado encontrado"
                                          :md-description="`Nenhum registro encontrado. Tente pesquisar com outra informação.`">
                    </md-table-empty-state>



                    <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single">
                        <md-tooltip md-direction="top">Veja mais detalhes</md-tooltip>
                        <md-table-cell :md-label="c.Titulo" :md-sort-by="c.Field" :v-width="c.width" v-for="c in Header" :key="c.Field">



                            <p class="s-h4 regular" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'texto'">{{item[c.Field]}}</p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'numero'">{{item[c.Field]}}</p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'date'" v-formatdate="item[c.Field]"></p>

                            <p class="s-h4 regular" style="text-align:center" :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'dataTime'" v-formatdatetime="item[c.Field]"></p>

                            <p class="s-h4 regular" style="text-align:center" v:tool :v-width="c.width" v-if="c.Titulo !='Link' && c.Titulo !='Detalhes' && c.Tipo == 'moeda'" v-formatmoeda="item[c.Field]"></p>

                            <div md-label="Acessar" v-if="c.Titulo != 'Ocultar' && c.Titulo =='Link'" width="30px">
                                <button v-on:click="acessarLink(item[c.Field])"><md-icon>link</md-icon></button>
                            </div>

                            <div md-label="c.Titulo" v-if="c.Tipo =='button' && item[c.Campo] == c.Condicao" width="30px">
                                <button v-on:click="buttonClick(item, c.Servico, c.Metodo, c.Acao)" class="button"><md-icon>description</md-icon></button>
                            </div>

                        </md-table-cell>
                    </md-table-row>

                </md-table>


                <div class="md-toolbar-section-start padding-20" v-if="Title">
                    <p>{{Title}} ({{searched.length}})</p>
                </div>

                <div v-if="selected" class="padding-20">
                    <div class="padding-20">
                        <md-table v-model='selected.titulosNegociados' md-card>
                            <md-table-toolbar>
                                <h4>Títulos Negociados:</h4>
                            </md-table-toolbar>

                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="Contrato" md-sort-by="contrato">{{ item.numeroContratoTituloOriginal }}</md-table-cell>
                                <md-table-cell md-label="Vencimento" md-sort-by="vencimento" v-formatdate="item.vencimento"></md-table-cell>
                                <md-table-cell md-label="Valor Original" md-sort-by="valor" v-formatmoeda="item.valorOriginal"></md-table-cell>
                                <md-table-cell md-label="Juros" md-sort-by="juros" v-formatmoeda="item.juros"></md-table-cell>
                                <md-table-cell md-label="Multa" md-sort-by="multa" v-formatmoeda="item.multa"></md-table-cell>
                                <md-table-cell md-label="Valor Desconto" md-sort-by="desconto" v-formatmoeda="item.desconto"></md-table-cell>
                                <md-table-cell md-label="Valor Acordo" md-sort-by="desconto" v-formatmoeda="item.valorAcordo"></md-table-cell>

                            </md-table-row>
                        </md-table>
                    </div>

                    <div class="padding-20">
                        <md-table v-model='selected.parcelas' md-card>
                            <md-table-toolbar>
                                <h4>Parcelas:</h4>
                            </md-table-toolbar>

                            <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClass(item)" md-selectable="single" v-on:click="onSelectParcela(item.linhaDigitavel)">
                                <md-table-cell md-label="Nosso Número" md-sort-by="nossoNumero">{{ item.nossoNumero }}</md-table-cell>
                                <md-table-cell md-label="Parcela" md-sort-by="numeroParcela">{{ item.numeroParcela }}</md-table-cell>
                                <md-table-cell md-label="Vencimento" md-sort-by="dataVencimento" v-formatdate="item.dataVencimento"></md-table-cell>
                                <md-table-cell md-label="Status" md-sort-by="status">{{ item.status }}</md-table-cell>
                                <md-table-cell md-label="Data Pagamento" md-sort-by="dataPagamento" v-formatdate="item.dataPagamento"></md-table-cell>
                                <md-table-cell md-label="Valor Pago" md-sort-by="valorPago" v-formatmoeda="item.valorPago"></md-table-cell>
                                <md-table-cell md-label="Pagamento" md-sort-by="formaPagamento">{{ item.formaPagamento }}</md-table-cell>
                                <md-table-cell md-label="Tipo" md-sort-by="tipo">{{ item.tipo }}</md-table-cell>
                                <md-tooltip md-direction="top">Clique para mais informações</md-tooltip>
                            </md-table-row>

                        </md-table>
                    </div>


                </div>

                <div v-if="selected" class="padding-20" style="color:#fff">
                    <p><strong>Linha selecionada:</strong></p>
                    {{ selected }}
                </div>

                <md-dialog :md-active.sync="linhaDigitavel" class="md-layout-item md-size-50 zindex">
                    <div class="padding-20">

                        <h2 class="divLeft200">Linha Digitável</h2>
                        <md-dialog-actions class="divRight">
                            <md-button class="md-primary" @click="linhaDigitavel = false">Fechar</md-button>
                        </md-dialog-actions>
                        <div style="clear:both"></div>
                        <div>
                            {{ selectedParcela }}
                        </div>
                    </div>

                </md-dialog>
            </md-content>

        </Loading>
    </div>



</template>

<script>

    import { formatdatetime } from '@/directives/formatdatetime.js';
    import { formatdate } from '@/directives/formatdate.js';
    import { formatmoeda } from '@/directives/formatmoeda.js';
    import Button from '@/services/ButtonService.js';
    import Loading from '@/components/Loading';


    export default {

        name: 'Grid',
        components: {
            Loading
        },
        directives: {
            formatdatetime,
            formatdate,
            formatmoeda
        },
        props: {
            Data: {
                type: Array
            },
            Header: {
                type: Array
            },
            Name: String,
            Title: String,
            OrderBy: String,
            DetalhesCombo1: {
                type: Object
            },
            DetalhesCombo2: {
                type: Object
            },
            DetalhesCombo3: {
                type: Object
            }
        },
        data:
            function () {
                return {
                    selected: null,
                    aluno: null,
                    dados: this.Data,
                    headers: this.Header,
                    search: '',
                    carregarDetalhes: false,
                    detalhesCombo1: this.DetalhesCombo1,
                    detalhesCombo2: this.DetalhesCombo2,
                    detalhesCombo3: this.DetalhesCombo3,
                    exibirCombo1: false,
                    exibirCombo2: false,
                    exibirCombo3: false,
                    valorDetalhes: [],
                    valorPesquisaCombo: [],
                    combo1: '',
                    combo2: '',
                    combo3: '',
                    showLoadingButton: false,
                    toolTipoDetalhes: "Veja mais detalhes",
                    selectedParcela: null,
                    linhaDigitavel: false
                }
            },

        methods: {

            buttonClick(parametros, servico, metodo, acao) {

                this.showLoadingButton = true;
                this.buttonService.Acao({
                    Parametros: parametros,
                    Servico: servico,
                    Metodo: metodo,
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoTurma: this.aluno.codigoTurma,
                    CodigoEmpresa: this.aluno.codigoEmpresa
                }).then(
                    data => {
                        if (data.ok) {
                            let download = data.dados;
                            switch (acao) {
                                case "pdf":


                                    this.$modal.info("O arquivo foi carregado em uma nova aba. Caso o mesmo não seja carregado, verificar se o bloqueio de pop-up está desabilitado para esse site.");
                                    window.open("http://boleto.pdf").document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64," + encodeURI(download) + "'></iframe>");
                                    break;
                            }
                        }
                        else {
                            this.$modal.alert(data.mensagem);
                        }
                    },
                    error => {
                        this.$modal.error('Ocorreu um erro ao executar a ação.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                    }).finally(() => {
                        this.showLoadingButton = false;
                    });
            },

            getClass: () => ({
                'md-primary': 2
            }),
            onSelect(item) {
                this.selected = item;
                this.selectedParcela = '';
            },
            onSelectParcela(item) {
                this.selectedParcela = item;
                this.linhaDigitavel = true;
            },
            limparPesquisa() {
                this.valorPesquisaCombo = [];
                this.combo1 = '';
                this.combo2 = '';
                this.combo3 = '';
                this.searched = this.dados;
                this.search = "";
            },

            changeCombo(valor, combo) {

                if (valor == "Todos") {

                    var valorCombo1 = this.combo1;
                    var valorCombo2 = this.combo2;
                    var valorCombo3 = this.combo3;

                    this.limparPesquisa();
                    switch (combo) {
                        case 1:
                            if (valorCombo2 && valorCombo2 != "Todos") {
                                this.valorPesquisadoCarregar(2, valorCombo2);
                                this.combo2 = valorCombo2;
                            }

                            if (valorCombo3 && valorCombo3 != "Todos") {
                                this.valorPesquisadoCarregar(3, valorCombo3);
                                this.combo3 = valorCombo3;
                            }
                            break;

                        case 2:
                            if (valorCombo1 && valorCombo1 != "Todos") {
                                this.valorPesquisadoCarregar(1, valorCombo1);
                                this.combo1 = valorCombo1;
                            }

                            if (valorCombo3 && valorCombo3 != "Todos") {
                                this.valorPesquisadoCarregar(3, valorCombo3);
                                this.combo3 = valorCombo3;
                            }
                            break;

                        case 3:
                            if (valorCombo1 && valorCombo1 != "Todos") {
                                this.valorPesquisadoCarregar(1, valorCombo1);
                                this.combo1 = valorCombo1;
                            }

                            if (valorCombo2 && valorCombo2 != "Todos") {
                                this.valorPesquisadoCarregar(2, valorCombo2);
                                this.combo2 = valorCombo2;
                            }
                            break;
                    }
                }
                else
                    this.valorPesquisadoCarregar(combo, valor);

                this.searchOnTable();
            },

            valorPesquisadoCarregar(combo, valor) {
                if (this.valorPesquisaCombo.find(element => element.Combo == combo))
                    this.valorPesquisaCombo.find(element => element.Combo == combo).Valor = valor.toString();
                else
                    this.valorPesquisaCombo.push({ Combo: combo, Valor: valor.toString() });
            },

            acessarLink(valor) {
                window.open(valor);
            },
            searchOnTable() {

                this.searched = [];
                this.searched = this.dados;
                let valorAntigo = ''
                if (this.search) {
                    valorAntigo = this.search;
                    this.searched = this.dados.filter(contemTexto(this.search, this.headers));
                }

                if (this.valorPesquisaCombo.length > 0) {
                    for (var i = 0; i < this.valorPesquisaCombo.length; i++) {
                        this.search = this.valorPesquisaCombo[i].Valor;
                        this.searched = this.searched.filter(contemTexto(this.search, this.headers));
                    }

                    this.search = valorAntigo;
                }
            }
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                }
                else
                    this.$router.push('home');
            }

            this.buttonService = new Button(this);

            this.searched = this.dados;
            if (this.detalhesCombo1 != null && this.detalhesCombo1.titulo != undefined) {
                this.combo1 = this.detalhesCombo1.dados[0].value;
                this.exibirCombo1 = true;
            }

            if (this.detalhesCombo2 != null && this.detalhesCombo2.titulo != undefined) {
                this.combo2 = this.detalhesCombo2.dados[0].value;
                this.exibirCombo2 = true;
            }

            if (this.detalhesCombo3 != null && this.detalhesCombo3.titulo != undefined) {
                this.combo3 = this.detalhesCombo3.dados[0].value;
                this.exibirCombo3 = true;
            }
        }
    }

    function contemTexto(search, headers) {
        return function (element) {

            for (var i = 0; i < headers.length; i++) {
                if (element[headers[i].Field] && element[headers[i].Field].toString().toLowerCase().includes(search.toLowerCase()))
                    return true;
            }

            return false;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .grid {
        width: 30em;
        overflow-x: auto;
        white-space: pre-wrap;
    }

    .theme-default {
        background-color: #9b9b9b;
        color: white;
    }

    .theme-primary {
        background-color: #448aff;
        color: white;
    }

    .theme-success {
        background-color: #009688;
        color: white;
    }

    .theme-danger {
        background-color: #ff5252;
        color: white;
    }

    .theme-warning {
        background-color: #f9aa33;
        color: white;
    }

    .align-right {
        float: right;
        padding: 20px;
    }

    .padding-20 {
        padding: 0 0 10px 20px;
    }

    .padding-pesquisar {
        padding: 0 0 0 30px;
    }


    .md-table-cell-container {
        padding: 0px;
    }

    .zindex {
        z-index: 1000;
    }

    .buttonLimpar {
        background-color: transparent;
        border: 0;
    }

    .filtro {
        height: 40px !important;
        font-size: 20px !important;
    }

    .color6361FB {
        color: #6361FB !important;
    }

    .option {
        background-color: #fff !important;
    }

        .option:hover {
            background-color: #6361FB !important;
        }

    .webkit-text-fill-color6361FB {
        -webkit-text-fill-color: #6361FB !important;
    }

    .border6361FB {
        border-bottom-color: #6361FB !important;
    }

    .semMargin {
        padding: 0 !important;
        margin: 0 !important;
    }

    .button {
        background-color: transparent;
        border: 0px;
    }

    .divLeft200 {
        width: 200px;
        float: left;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }

    .divRight {
        width: 100px;
        float: right;
        position: relative;
        display: inline;
        padding: 5px 0 0 5px
    }

    
</style>
